module.exports = __webpack_public_path__ + "img/how-to_image03.14567a9b.png";